import { ReactNode } from 'react';

import { Variant, variants } from './variant';

import './bizos-typography.styles.scss';

export type BizosTypographyProps = {
    variant?: Variant;
    weight?: 'normal' | 'bold';
    color?: 'light-gray' | 'gray';
    children: ReactNode;
};

const BizosTypography = ({
    variant = 'paragraph',
    weight = 'normal',
    color = 'light-gray',
    children,
}: BizosTypographyProps) => {
    const Component = variants[variant];
    const className = [`bizos-typography__${variant}`, `bizos-typography__${variant}--${weight}`, color];
    return <Component className={className.join(' ')}>{children}</Component>;
}

export default BizosTypography;
